/* eslint-disable prefer-template */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable func-names */
/* eslint-disable prefer-const */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
import React from 'react';
import AppleSignin from 'react-apple-signin-auth';
import Cookies from 'js-cookie';
import loginApple from '@assets/images/social-media-icons/apple.png';

import { userLoggedIn, socialMediaLogin, ssoLogin } from '@features/Authentication/services/authenticationApi';
import setSegmentIdentity from '@shared/utils/SetSegmentIdentity';
import unsetSegmentIdentity from '@shared/utils/UnsetSegmentIdentity';

export default function LoginViaApple({
  modalFunc,
  loggedInFunc,
  appleError,
  ...props
}) {
  function userProfile(userToken) {
    userLoggedIn(userToken)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.code === '200') {
            Cookies.set('uid', response.data.data.user_id, { expires: 90, secure: true });
            modalFunc({
              modalStatus: false,
            });
            loggedInFunc({
              loggedIn: response.data.data,
              modalStatus: false,
            });
            // segment tracking
            if (process.env.REACT_APP_ON_SEGMENT === 'true') {
              // segment set identify call
              if (response.data.data.guid) {
                setSegmentIdentity(response.data.data.guid);
              // segment unset identify call
              } else {
                unsetSegmentIdentity();
              }
              // login success segment event
              window.analytics.track('Login Succeeded', {
                login_method: 'Apple',
              });
            }
          }
        }
      });
  }

  function parseJwt(token) {
    let base64Url = token.split('.')[1];
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    let jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
  }

  function processAppleLogin(dataApple) {
    socialMediaLogin(dataApple)
      .then(async (socRes) => {
        if (socRes.data.status === 'error') {
          appleError();
        } else {
          const ssoData = new URLSearchParams({
            otp: socRes.data.data.otp,
            username: socRes.data.data.user_guid,
          });
          await ssoLogin(ssoData)
            .then(async (ssoRes) => {
              if (ssoRes.data.code === '200') {
                Cookies.set('token', ssoRes.data.data.access_token, { expires: 90, secure: true });
                const userToken = ssoRes.data.data.access_token;
                userProfile(userToken);
              } else if (ssoRes.data.code !== '200') {
                // login failed segment event
                window.analytics.track('Login Failed', {
                  login_method: 'Apple',
                  error_message: ssoRes.data.data.error_description
                    ? ssoRes.data.data.error_description
                    : ssoRes.data.message,
                });
              }
            }).catch((error) => {
              console.error(error);
              // login failed segment event
              window.analytics.track('Login Failed', {
                login_method: 'Apple',
                error_message: error,
              });
            });
        }
      });
  }

  const responseApple = (response) => {
    if (response.authorization.id_token) {
      const appleLoginData = parseJwt(response.authorization.id_token);
      const appleId = appleLoginData.sub;
      const dataApple = new URLSearchParams({
        oauth_provider: 'apple',
        oauth_id: appleId,
      });
      processAppleLogin(
        dataApple,
      );
    }
    const errorAppleMessage = 'User is not fully authorized.';
    // login failed segment event
    window.analytics.track('Login Failed', {
      login_method: 'Apple',
      error_message: errorAppleMessage,
    });
  };

  function appleAgree(onClick) {
    onClick();
  }

  return (
    <div>
      <AppleSignin
        /** Auth options passed to AppleID.auth.init() */
        authOptions={{
          clientId: process.env.REACT_APP_APPLE_CLIENT_ID,
          scope: 'email name',
          redirectURI: process.env.REACT_APP_APPLE_REDIRECT_URI,
          state: '',
          nonce: 'nonce',
          usePopup: true,
        }}
        /** General props */
        uiType='dark'
        /** className */
        className='apple-auth-btn'
        noDefaultStyle={false}
        onSuccess={responseApple} // default = undefined
        /** Called upon signin error */
        buttonExtraChildren='Continue with Apple'
        onError={(error) => console.error(error)} // default = undefined
        /** Allows to change the button's children, eg: for changing the button text */
        /** Checkout README.md for further customization props. */
        /** Spread rest props if needed */
        iconProp={{ style: { marginTop: '10px' } }}
        render={(renderProps) => (
          <div onClick={() => appleAgree(renderProps.onClick)} {...props}>
            <div className='apple-button-container'>
              <img src={loginApple} alt='login-via-apple' className='apple-login' />
              <p>Continue with Apple</p>
            </div>
          </div>
        )}
      />
    </div>
  );
}
